import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";
import styled, { createGlobalStyle } from "styled-components";

import Brands from "./app/Brands";
import ProductLine from "./app/ProductLine";
import ProductLines from "./app/ProductLines";
import AppHeader from "../../components/AppHeader";
import { NotificationsProvider } from "../../components/Notifications";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

export type ProductLinesAppOutletContext = UnsavedChangesContext;

const GlobalStyle = createGlobalStyle`
    :root {
    }
`;

const Styled = styled.div`
    display: grid;
    grid-template-columns: 1fr minmax(0, 1fr) 2fr;
    gap: 4vw;
    padding: 128px 128px 64px 192px;

    & > *:not(:last-child):not(:hover):not(:has(input:focus)) {
        opacity: .4;
    }
`;


function App() {
    const guard = useUnsavedChangesRefs();

    return (
        <NotificationsProvider>
            <Helmet>
                <title>Product Lines</title>
            </Helmet>
            <GlobalStyle />
            <AppHeader title={ <>product<br />lines</> } guard={ guard } />
            <Styled>
                <Outlet context={ guard satisfies ProductLinesAppOutletContext } />
            </Styled>
        </NotificationsProvider>
    );
}

export default (
    <Route Component={ App } path="product-lines">
        <Route Component={ Brands }>
            <Route index />
            <Route Component={ ProductLines } path=":brandID">
                <Route index />
                <Route Component={ ProductLine } path="new" />
                <Route Component={ ProductLine } path=":productLineID" />
            </Route>
        </Route>
    </Route>
);
